function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.4992 30.489C31.2587 29.723 31.2554 28.4861 30.492 27.7241L25.1085 22.3551C26.7647 20.1333 27.7459 17.3804 27.7459 14.4023C27.7459 7.04792 21.7622 1.06667 14.4063 1.06667C7.05034 1.06667 1.06667 7.04793 1.06667 14.4023C1.06667 21.7566 7.0504 27.7379 14.4063 27.7379C17.3755 27.7379 20.1212 26.7633 22.34 25.1172L27.7342 30.4971C28.1148 30.8759 28.6143 31.0667 29.1127 31.0667C29.6139 31.0667 30.1178 30.8732 30.4992 30.489ZM21.0513 21.0731C21.088 21.0362 21.1257 21.001 21.1645 20.9677C22.8181 19.2692 23.8378 16.952 23.8377 14.4022C23.8377 9.2081 19.6068 4.97965 14.4063 4.97965C9.20576 4.97965 4.9748 9.2081 4.9748 14.4022C4.9748 19.596 9.20578 23.8248 14.4063 23.8248C16.9502 23.8248 19.2622 22.8129 20.9604 21.1711C20.9892 21.1379 21.0199 21.1048 21.0513 21.0731Z",
  fill: "black"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.ee0844ff.svg";
export { ForwardRef as ReactComponent };